export const shouldDisableSubmitButton = (formState) => {
    const { submitting, hasValidationErrors, hasSubmitErrors, modifiedSinceLastSubmit } = formState;
    return submitting || hasValidationErrors || (hasSubmitErrors && !modifiedSinceLastSubmit);
};
